<template>
  <div class="agent-notes">
    <div class="container-wrapper">
      <div class="content" v-html="state.content"></div>
    </div>
  </div>
</template>
<script setup>
import { getDocIssue } from '@/apis/resource';
import { useUserStore } from '@/stores';
import { reactive } from 'vue';

const userStore = useUserStore();
const state = reactive({
  title: '',
  content: ''
});
const getDocIssueFun = async () => {
  const res = await getDocIssue('ACBUY-0104');
  let langItem = res.data.langList.find(
    item => item.lang === userStore.language
  );
  state.title = langItem.title;
  state.content = langItem.content;
};
getDocIssueFun();
</script>
<style scoped lang="scss">
.agent-notes {
  padding: 40px 0;
  color: var(--black-color-9);

  .content {
    :deep(p) {
      color: var(--black-color-9) !important;
    }

    :deep(span) {
      color: var(--black-color-9) !important;
    }
  }
}
</style>
